import axios from "axios";
import authHeader from "./auth-header";
import authAdminHeader from "./auth-admin-header";
// export const API_URL = "https://pharma-dev.custodiy.com/api/";
export const API_URL = "https://api.pharmacrowd.net/api/";
const register = (data) =>
  axios.post(`${API_URL}register`, data);
const verifyOtp = (otp, email) =>
  axios.post(`${API_URL}varifyOtp`, {
    otp,
    email,
  });
const resendOtp = (email) =>
  axios.post(`${API_URL}resendEmailVerfication`, {
    email,
  });
const forgetPass = (email, recaptchaToken) =>
  axios.post(`${API_URL}forgotPassword`, {
    email,
    recaptcha_token: recaptchaToken,
  });
const changePassword = (password, newPassword, recaptchaToken) =>
  axios.post(
    `${API_URL}changePassword`,
    {
      password,
      newPassword,
      recaptcha_token: recaptchaToken,
    },
    { headers: authHeader() }
  );
const login = async (email, password) =>
  axios
    .post(`${API_URL}login`, {
      email,
      password,
    })
    .then((response) => {
      localStorage.setItem("user", JSON.stringify(response.data));

      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });

const adminSwitchProfile = async (data) =>
  axios
    .post(
      `${API_URL}adminSwitchProfile`,

      data,

      { headers: authAdminHeader() }
    )
    .then((response) => {
      localStorage.setItem("user", JSON.stringify(response.data));

      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });

const logout = () => {
  localStorage.removeItem("user");
};
// export const sendToken = async (amount, receiver, coin, otp) =>
//   axios.post(
//     `${API_URL}sendToken`,
//     {
//       amount,
//       receiver,
//       coin,
//       otp,
//     },
//     { headers: authHeader() }
//   );
const varifyPasswordotp = (email, otp) =>
  axios.post(`${API_URL}varifyPasswordotp`, {
    email,
    otp,
  });
const resetPassword = (email, otp, password, confirmPassword, recaptchaToken) =>
  axios.post(`${API_URL}resetPassword`, {
    email,
    otp,
    password,
    confirmPassword,
    recaptcha_token: recaptchaToken,
  });
const verifyTwoFactor = (otp, email) =>
  axios
    .post(
      `${API_URL}varify_2fa_otp`,
      {
        otp,
        email,
      },
      { headers: authHeader() }
    )
    .then((response) => {
      localStorage.setItem("user", JSON.stringify(response.data));

      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
export default {
  register,
  login,
  forgetPass,
  logout,
  verifyOtp,
  resendOtp,
  // sendToken,
  changePassword,
  resetPassword,
  varifyPasswordotp,
  verifyTwoFactor,
  adminSwitchProfile,
};
